import { render, staticRenderFns } from "./CatalogCourse.vue?vue&type=template&id=706bb0ec&scoped=true&"
import script from "./CatalogCourse.vue?vue&type=script&lang=js&"
export * from "./CatalogCourse.vue?vue&type=script&lang=js&"
import style0 from "./CatalogCourse.vue?vue&type=style&index=0&id=706bb0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706bb0ec",
  null
  
)

export default component.exports